/**
 * Export
 */

exports = module.exports = detect;

/**
 * Check if process is running in the browser
 *
 * @return {Boolean}
 * @api public
 */

function detect() {
  if (typeof window != "undefined") return true;
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/is-client/index.js
// module id = 29
// module chunks = 0